import {
  isExternalMedia,
  isExternalMediaWeblink,
  isMedialinkStudentAssignment,
  isMiniSite,
  Medialink,
} from '../api/medialink';

/**
 * @deprecated use getLinkFromMedialink from api instead
 */
export function getLinkFromMedialink(medialink: Medialink) {
  if (isMiniSite(medialink) && medialink.miniSite?.target === 'new-window') {
    return medialink.miniSite.href;
  }

  if (
    isExternalMedia(medialink) &&
    isExternalMediaWeblink(medialink) &&
    medialink.externalMedia.target === 'new-window'
  ) {
    return medialink.externalMedia.href;
  }

  return;
}

/**
 * @deprecated use validateAndGetLinkFromMedialink from api instead
 */
export function validateAndGetLinkFromMedialink(medialink: Medialink) {
  if (isMedialinkStudentAssignment(medialink)) return undefined;

  return getLinkFromMedialink(medialink);
}

export const EXERCISE_KINDS = ['exercise-edumatic', 'exercise-eduhint', 'exercise-assessmentq'];

/**
 * @deprecated use isScorableMedialink from api instead
 */
export function checkIsExercise(kind: string) {
  return EXERCISE_KINDS.includes(kind);
}

type MaterialWithHierarchy = { hierarchy?: Array<{ id: string }> };

export const groupMaterialsByNode = <T extends MaterialWithHierarchy>(materials: T[]) => {
  return materials.reduce<Record<string, T[]>>((groupedMaterials, material) => {
    const node = material.hierarchy?.[material.hierarchy.length - 1];

    if (!node) return groupedMaterials;

    return {
      ...groupedMaterials,
      [node.id]: [...(groupedMaterials[node.id] || []), material],
    };
  }, {});
};
